import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {AbstractControl, UntypedFormGroup} from '@angular/forms';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ActivatedRoute, Router} from '@angular/router';
import {BaseApiService} from '@atmi/core';
import {Base, BaseMeta, Nullable} from '@atmi/core/models';
import {TranslateService} from '@ngx-translate/core';
import {FormManagerService} from '@sim/form';
import {NgxSpinnerService} from 'ngx-spinner';
import {firstValueFrom} from 'rxjs';


@Component({
  selector: 'app-add-base-dialog',
  templateUrl: './add-base-dialog.component.html',
  styleUrls: ['./add-base-dialog.component.scss']
})
export class AddBaseDialogComponent implements OnInit {
  entityForm!: UntypedFormGroup;
  entityControls?: { [P in keyof Base]: Nullable<AbstractControl> };

  @Output()
  done: EventEmitter<Base | string> = new EventEmitter<Base | string>();

  constructor(
    public dialogRef: MatDialogRef<AddBaseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    protected readonly snackBarService: MatSnackBar,
    protected readonly translate: TranslateService,
    protected readonly route: ActivatedRoute,
    protected readonly router: Router,
    protected readonly formManager: FormManagerService,
    protected readonly spinner: NgxSpinnerService,
    private readonly baseApi: BaseApiService) {
  }

  ngOnInit(): void {
    this.entityForm = this.formManager.makeForm(BaseMeta);
    this.entityControls = this.formManager.getControls(this.entityForm);
  }

  handleDone($event: Base | undefined) {
    this.dialogRef.close($event);
  }

  async createAndAddToObject() {
    const base: Base = this.entityForm.value;
    this.spinner.show();
    try {
      const createRes = await firstValueFrom(this.baseApi.post(base));
      this.handleDone(createRes);
    } catch (err) {
      console.error(err);
      this.snackBarService.open(err.message);
      this.handleDone(undefined);
    } finally {
      this.spinner.hide();
    }
  }

}
